import { BaseParameterDto } from './../base-parameter-dto';

export class RegistrationEditorParametersDto extends BaseParameterDto {
  customerId: string;
  checkDigit: number;
  email: string;
  recaptchaToken: string;

  override getQueryString(): string {
    const encodedCustomerId = encodeURIComponent(this.customerId);
    const encodedEmail = encodeURIComponent(this.email || '');
    const encodedRecaptchaToken = encodeURIComponent(this.recaptchaToken || '');

    return `?customerId=${encodedCustomerId}&checkDigit=${this.checkDigit}&email=${encodedEmail}&recaptchaToken=${encodedRecaptchaToken}&clearCache=${this.clearCache}`;
  }
}
